// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-321db580] .el-dialog {\n  margin-left: 60% !important;\n}\n.container[data-v-321db580] {\n  padding: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
